import { Accordion, ActionButton, Button, Checkbox, Disclosure, DisclosurePanel, DisclosureTitle, Divider, Flex, Heading, Item, Link, TagGroup, Text, TextField, View } from "@adobe/react-spectrum";
import PersonDropdown from "../formComponents/PersonDropDown";
import { useEffect, useRef, useState } from "react";
import { ContactFormData } from "../AddNewPerson";
import { EditIcon } from "../../../../../components/protected/Icons/IconsLib";
import { truncateText } from "../../../../../utils/helperUtil";
import { Check, ExclamationTriangle, Plus } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
interface IBankSectionProps{
  data: ContactFormData['banks'];
  onChange: (data: ContactFormData['banks']) => void;
  onAdd: () => void;
  expandedSectionKey:any
  setExpandedSectionKey:(data:any)=>void;
  validationErrors:any
  setValidationErrors : (data:any)=>void;
  fieldConfig:any
  validationStatus:any
  setValidationStatus:(data:any)=>void;
  contactType:string
}
const BankSection: React.FC<IBankSectionProps> = ({ data, onChange,onAdd,expandedSectionKey,setExpandedSectionKey,validationErrors,
  setValidationErrors,
  fieldConfig,
  validationStatus,
  setValidationStatus,contactType }) => {
    const [expandedSections, setExpandedSections] = useState<Set<number>>(new Set());
    const [isSectionRequired,setIsSectionRequired] = useState(false);
    const nameFieldRefs = useRef<Record<number, any | null>>({});
    const [saveBank,setSaveBank] = useState(false);
    const { t } = useTranslation('contacts');
    const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });

          // useEffect(() => {
          //     if(fieldConfig?.industry?.required
          //     ){
          //       setValidationStatus((prev:any) => ({ ...prev, ['industriesSection']: false }));
          //       setIsSectionRequired(true)
          //     } 
          //   }, [fieldConfig]);
  const buttonRef = useRef<any>(null);
  useEffect(() => {
  if (expandedSectionKey?.has?.("bankSection") || saveBank) {
    setTimeout(() => {
      buttonRef.current?.focus();
      setSaveBank(false);
    }, 200); 
  }
}, [expandedSectionKey,saveBank]);



    const handleAddBank = ()=>{
        const index = data.length;
        onAdd();
        setExpandedSections((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
              newSet.delete(index);
            } else {
              newSet.add(index);
            }
            return newSet;
          });

          setTimeout(() => {
            nameFieldRefs.current[index]?.focus();
          }, 200); 
    }

    const onRemove = (index:number) => {
      const updatedContacts = data.filter((_, i) => i !== index);
      setExpandedSections((prev) => {
        const newSet = new Set(prev);
        newSet.delete(index);
        return newSet;
      }); 
      onChange(updatedContacts); 
    };

    const onCancel = (index:number) => {
      const existingContacts:any = data.find((_, i) => i === index);
      if(existingContacts.name === ''){
        const updatedContacts = data.filter((_, i) => i !== index);
        setExpandedSections((prev) => {
          const newSet = new Set(prev);
          newSet.delete(index);
          return newSet;
        }); 
        onChange(updatedContacts); 
      }
    };
  
    const onEdit = (index:number)=>{
      setSaveBank(true);
      setExpandedSections((prev) => {
        const newSet = new Set(prev);
        if (newSet.has(index)) {
          newSet.delete(index);
        } else {
          newSet.add(index);
        }
        return newSet;
      });
    }

    const updatePrimary = (value: boolean, index: number) => {
      const primaryCount = data.filter(item => item.isPrimary === '1').length;
      if (!value && primaryCount === 1) {
        return;
      }
      const newData = data.map((item, i) => ({
        ...item,
        isPrimary: i === index ? '1' : '0',
      }));
      onChange(newData);
    };
    const handleSectionExpandedChange = () => {
      setExpandedSectionKey((prevKey:any) => prevKey.has("bankSection") ? new Set() : new Set(["bankSection"]));
    };
    
    const handleConfirm = ()=>{
      if(contactType === 'p'){
        setExpandedSectionKey(new Set(['employmentSection']))
      }else{
        setExpandedSectionKey(new Set(['employeeSection']))
      }
    }
    return (
      <Accordion isQuiet expandedKeys={expandedSectionKey} onExpandedChange={handleSectionExpandedChange}>
          <Disclosure id='bankSection'>
            <DisclosureTitle><Flex justifyContent="space-between" alignItems="center" width="100%">
                              <View><span>{_tt(`Banks`)}</span><span style={{color:'#B0BEC5',fontFamily:'Adobe Clean'}}>{isSectionRequired && ` (${_tt('required')})`}</span></View>
                               {validationStatus.bankSection ? <Check size={20} color="#1976D2" /> :<ExclamationTriangle size={20} color="#FF9800" />}
                            </Flex></DisclosureTitle>
            <DisclosurePanel>
              <Divider size='M' UNSAFE_style={{marginBottom:10}}/>
            <Flex direction="column" gap="size-100" width='100%'>
      {data.map((tag, index) => ( 
              <View>
                {!expandedSections.has(index) &&
                <Flex key={index} gap="size-100" direction='row' width='100%'>
                    <TagGroup
                    items={data}
                    onRemove={()=>onRemove(index)}
                    aria-label="Removable TagGroup example"
                    width="100%"
                    >
                    <Item aria-label={tag.name}>{tag.name ? truncateText(tag.name,50): ''}</Item>
                    </TagGroup>
                    <a onClick={()=>onEdit(index)}>
                        <EditIcon size={20}/> 
                    </a>
                    <Checkbox
                          aria-label="Primary"
                          isSelected={tag.isPrimary == '1' ? true: false}
                          onChange={(value)=>updatePrimary(value,index)}
                      >
                    </Checkbox>
                </Flex>
                }
              {expandedSections.has(index) &&(
                  <Flex key={index+1} direction='column'>
                  <Flex direction="column" gap="size-100">
                <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
                <TextField 
                    label={_tt("bank_name")}
                    aria-label={_tt("bank_name")}
                    value={tag.name} 
                    onChange={(name) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, name }; 
                      onChange(newData); 
                    }} 
                    width="100%" 
                    ref={(el:any) => nameFieldRefs.current[index] = el}
                  />
                  <TextField 
                    label={_tt("domestic_bank")}
                    aria-label={_tt("domestic_bank")}
                    value={tag.bankName} 
                    onChange={(bankName) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, bankName }; 
                      onChange(newData); 
                    }} 
                    width="100%" 
                  />
                </Flex>
                <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
                <TextField 
                    label={_tt("bank_account")}
                    aria-label={_tt("bank_account")}
                    value={tag.account} 
                    onChange={(account) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, account }; 
                      onChange(newData); 
                    }} 
                    width="100%" 
                  />
                  <TextField 
                    label={_tt("bank_code")}
                    aria-label={_tt("bank_code")}
                    value={tag.bankCode} 
                    onChange={(bankCode) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, bankCode }; 
                      onChange(newData); 
                    }} 
                    width="100%" 
                  />
                </Flex>
                <Flex direction={{base:'column',L:'row'}} gap={'size-100'}>
                <TextField 
                    label={_tt("foreign_bank")}
                    aria-label={_tt("foreign_bank")}
                    value={tag.bankNoteForeign} 
                    onChange={(bankNoteForeign) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, bankNoteForeign }; 
                      onChange(newData); 
                    }} 
                    width={{base:'100%',L:"51%"}}
                  />
                  <TextField 
                    label={_tt("Iban_code")}
                    aria-label={_tt("Iban_code")}
                    value={tag.bankIBAN} 
                    onChange={(bankIBAN) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, bankIBAN }; 
                      onChange(newData); 
                    }} 
                    width={{base:'100%',L:"25%"}}
                  />
                  <TextField 
                    label={_tt("swift_code")}
                    aria-label={_tt("swift_code")}
                    value={tag.swiftCode} 
                    onChange={(swiftCode) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, swiftCode }; 
                      onChange(newData); 
                    }} 
                    width={{base:'100%',L:"25%"}}
                  />
                </Flex>
                  <TextField 
                    label={_tt("comment")}
                    aria-label={_tt("comment")}
                    value={tag.comment} 
                    onChange={(comment) => { 
                      const newData = [...data]; 
                      newData[index] = { ...tag, comment }; 
                      onChange(newData); 
                    }} 
                    width="100%" 
                  />
                  </Flex>
                  <Flex direction="row" gap={'size-100'} marginTop={10} justifyContent='end'>
                    <ActionButton onPress={()=>onCancel(index)} isQuiet UNSAFE_style={{color:'#1976D2'}}>{_tt('button_cancel')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
                    <View>
                      <ActionButton onPress={()=>onEdit(index)} isQuiet UNSAFE_style={{color:'#1976D2'}}>{_tt('button_save')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
                    </View>
                  </Flex>
                  </Flex>
              )
              }
              </View>
            ))}
            {data.length > 0 &&
              <Divider size='M' aria-label="" /> 
            }
        <Flex gap="size-100" direction='row' width='100%' justifyContent={'space-between'}>
            <Button variant='accent' ref={buttonRef} onPress={handleAddBank}><Plus size={22} /> {_tt('button_add_bank')}</Button>
            <ActionButton onPress={handleConfirm} isQuiet UNSAFE_style={{color:'#1976D2',padding:10}}><Check size={22} color='#1976D2' /> {_tt('button_confirm')}</ActionButton> {/*active:#1976D2, disabled:#B0BEC5*/}
        </Flex>
      </Flex>
            </DisclosurePanel>
            </Disclosure>
            </Accordion>
  );
}
export default BankSection